module.exports = __webpack_public_path__ + "377cb65753ecc01b035f69897425bcb3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-neon-green-s.png
// module id = 2011
// module chunks = 0